'use strict';

// file-dropzone.js — все обработчики делегированные, инициализация не нужна

require('./file-dropzone/drag');
require('./file-dropzone/click');
require('./file-dropzone/paste');
require('./file-dropzone/upload');

// Delete file (edit mode) — только убираем элемент из DOM, файл на диске остаётся
jQuery(document).on('click', '.btn-remove-file', function () {
    let item = jQuery(this).closest('.file-dropzone-item');

    window.openConfirmModal({
        message: 'Удалить файл «' + item.data('file-name') + '»? ',
        callback: function () {
            item.remove();
            if (typeof window.showToast === 'function') {
                window.showToast('Файл убран из формы', 'success');
            }
        }
    });
});